export default {"width":1280,"height":994};